var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "text-body-2 text-secondary--text text-center",
      class: {
        "px-8":
          _setup.isMobile &&
          _setup.appointmentDataStore.appointmentObjectTypes.isServices,
        "px-4":
          _setup.isMobile &&
          _setup.appointmentDataStore.appointmentObjectTypes.isDoctor,
      },
      attrs: { "data-qa": "personal_data" },
    },
    [
      _vm._v(
        "\n  " + _vm._s(_setup.t("Записываясь на", _setup.options)) + "\n  "
      ),
      _c(
        "span",
        { attrs: { "data-qa": "personal_data_appointment_object_type_text" } },
        [_vm._v(_vm._s(_setup.t(_setup.appointmentObjectType, _setup.options)))]
      ),
      _vm._v(
        ",\n  " +
          _vm._s(_setup.t("вы даете согласие на", _setup.options)) +
          "\n  "
      ),
      _c(
        "a",
        {
          staticClass: "link-decoration-none primary--text d-inline",
          attrs: {
            "data-qa": "personal_data_privacy_policy",
            target: "_blank",
            href: "/info/privacy-policy/",
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _setup.t("обработку персональных данных", _setup.options)
              ) +
              "\n  "
          ),
        ]
      ),
      _vm._v(
        "\n  " + _vm._s(_setup.t("и принимаете", _setup.options)) + "\n  "
      ),
      _c(
        "a",
        {
          staticClass: "link-decoration-none primary--text d-inline",
          attrs: {
            "data-qa": "personal_data_terms_of_use",
            target: "_blank",
            href: "/info/terms-of-use/",
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_setup.t("пользовательское соглашение", _setup.options)) +
              "\n  "
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }